module.exports = __webpack_public_path__ + "static/onmymind_banner-672b4f68029fe9f92529fd0e63ae4689.png";